import { defaultStyles } from '../../library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    calculation: {
        '@media print': {
            backgroundColor: defaultStyles.white,
        },
    },
    resultContainer: {
        background: defaultStyles.greyBackground,
        '@media print': {
            paddingBottom: '32px',
        }
    },
    buttonWrapper: {
        marginBottom: '32px',
        textAlign: 'center',
        '@media print': {
            display: 'none',
        },
    },
    title: {
        '@media print': {
            color: defaultStyles.black,
        },
    },
    subTitle: {
        color: defaultStyles.blue,
        fontSize: '1.5rem',
        lineHeight: '1.2',
        textTransform: 'uppercase',
        fontWeight: '700',
        margin: '20px 0 10px',
        '@media print, screen and (min-width: 480px)': {
            fontSize: '1.875rem',
        },
        '@media print, screen and (min-width: 990px)': {
            fontSize: '2.625',
        },
    },
    suggestionContainer: {
        display: 'flex',
        flexDirection: 'column',
        color: defaultStyles.blue,
        justifyContent: 'space-around',
        textAlign: 'center',
        '@media print, screen and (min-width: 990px)': {
            flexDirection: 'row',
        },
        '@media print': {
            color: defaultStyles.black,
        },
    },
    flexContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
    },
    legal: {
        padding: '0 30px 30px',
        textAlign: 'center',
        color: defaultStyles.greyText,
        fontSize: '16px',
        fontWeight: '400',
        '@media print': {
            color: defaultStyles.black,
        },
    },
    legalResult: {

        backgroundColor: defaultStyles.greyBackground,
    },
    resultImage: {
        height: '64px',
        margin: 'auto',
    },
    totalWeightWrapper: {
        textAlign: 'center',
    },
    totalWeight: {
        fontWeight: '700',
        paddingBottom: '10px',
        fontSize: '24px',
    },
    productName: {
        fontWeight: '400',
        fontSize: '16px',
    },
    orLabelWrapper: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '700',
        fontSize: '1.5rem',
        justifyContent: 'space-around',
        paddingTop: '2rem',
        '@media print, screen and (min-width: 990px)': {
            paddingTop: '0',
        }
    },
    packagingWrapper: {
        textAlign: 'center',
    },
    packaging: {
        fontSize: '24px',
        paddingBottom: '10px',
    },
    resultButtonWrapper: {
        padding: '2rem 10% 1rem',
        backgroundColor: defaultStyles.blue,
        width: '100%',
        '@media screen and (min-width: 990px)': {
            width: '50%',
            float: 'left',
            padding: '0',
        },
        '@media print': {
            display: 'none',
        }
    },
    resultButtonWrapperOnly: {
        '@media screen and (min-width: 990px)': {
            width: '100%',
        },
    },
    resultButton: {
        width: '100%',
        '@media print, screen and (min-width: 990px)': {
            width: '80%',
            margin: '3rem auto 2rem',
        }
    },
    productResultWrapper: {
        padding: '40px 30px 50px',
        backgroundColor: defaultStyles.greyBackground,
        clear: 'left',
        '@media print': {
            display: 'none'
        }
    },
    clearfix: {
        clear: 'both',
    }
});

export default styles;